import * as React from 'react';
import {
	ValuePropsSectionWrapper,
	Wrapper,
    Title
} from './ValuePropsSectionStyles';
import {language} from './ValuePropsSectionLanguage'
import {ValuePropsListLayout} from "./Layouts/ValuePropListLayout/ValuePropsListLayout";
import {ValuePropsItemsLayout} from "./Layouts/ValuePropsItemsLayout/ValuePropsItemsLayout";

export type Props = {
	valuePropsSectionProps: any
};

export const ValuePropsSectionLayout = (props: Props) =>
{
	const render = () =>
	{
		const returnValue = (
			<ValuePropsSectionWrapper>
				{/*<Wrapper>*/}
				{/*	<Title>*/}
				{/*		{props.valuePropsSectionProps.title}*/}
				{/*	</Title>*/}
				{/*	<ValuePropsListLayout valueProps={props.valuePropsSectionProps.valueProps} />*/}
				{/*</Wrapper>*/}
				<Wrapper>
					<Title>
						{props.valuePropsSectionProps.title}
					</Title>
					<ValuePropsItemsLayout valueProps={props.valuePropsSectionProps.valueProps} />
				</Wrapper>
			</ValuePropsSectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
